import type { ConnectionState, Message } from '@navstation-portal/iframe/data-model/message-type';
import type { SharedAppSettings } from '@navstation-portal/shared/data-model/remote-app-config';

export interface RemoteState {
  iframeId: string | null;
  state: ConnectionState;
  parentOrigin: string | null;
  headless: boolean;
  settings: SharedAppSettings;
  messages: Message[];
  error: string | null;
}

export const initialRemoteState: RemoteState = {
  iframeId: null,
  state: 'disconnected',
  parentOrigin: null,
  headless: false,
  settings: {},
  messages: [],
  error: null,
};
